
export class DHDeptModel {
    
    Id: any;
    DepartmentName: any;
    TypeCode: any;
    IsActive:any;
    
}